import { InputBuildProps } from "components/molecules/InputBuild/interfaces";

type FormFilterField = {
    input?: InputBuildProps;
    select?: any;
    layout?: any;
};

const optionsStatus = [
    {
        text: "Disponível",
        value: "DISPONIVEL",
    },
    {
        text: "Falha",
        value: "FALHA",
    },
    {
        text: "Utilizado",
        value: "INDISPONIVEL",
    },
];

const optionsUfDetran = [
    {
        text: "RJ",
        value: "RJ",
    },
    {
        text: "RS",
        value: "RS",
    },
];

const optionsStatusRegistration = [
    {
        text: "Ativo",
        value: "true",
    },
    {
        text: "Inativo",
        value: "false",
    },
];

const optionsPublica = [
    {
        text: "Livre concorrência",
        value: "false",
    },
    {
        text: "Preço Público Detran",
        value: "true",
    },
];

const optionsTipoVeiculo = [
    { text: "Todos", value: "TODOS" },
    { text: "Moto", value: "MOTO" },
    { text: "Demais veículos", value: "DEMAIS_VEICULOS" },
];

const detran: FormFilterField[] = [
    {
        select: {
            id: "uf",
            label: "UF",
            options: optionsUfDetran,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 2,
            },
        },
    },
    {
        input: {
            id: "cnpj",
            label: "CNPJ",
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        select: {
            id: "status",
            label: "Status",
            options: optionsStatus,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        input: {
            id: "numeroTaxa",
            label: "N° Documento",
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
];

const registration: FormFilterField[] = [
    {
        select: {
            id: "tipoVeiculo",
            label: "Tipo Veículo",
            options: optionsTipoVeiculo,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        input: {
            id: "dataInicio",
            label: "Data Inicial",
            placeholder: "dd/mm/aaaa",
            type: "date",
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        input: {
            id: "dataFim",
            label: "Data Final",
            placeholder: "dd/mm/aaaa",
            type: "date",
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        select: {
            id: "status",
            label: "Status",
            options: optionsStatusRegistration,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        select: {
            id: "uf",
            label: "UF",
            optionsType: "uf",
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        input: {
            id: "cnpjAgenteFinanceiro",
            label: "CNPJ Agente Financeiro",
            maskReplace: "cnpj",
            inputMode: "numeric",
            maxLength: 18,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
    {
        select: {
            id: "publica",
            label: "Preço",
            options: optionsPublica,
        },
        layout: {
            type: "col",
            layout: {
                base: 12,
                md: 3,
            },
        },
    },
];

export const formFilter = (
    type: "detran" | "price" | "tax",
): FormFilterField[] => {
    if (type === "detran") return detran;
    if (type === "price") return registration;
    return registration.filter(
        (field) =>
            field.input?.id !== "cnpjAgenteFinanceiro" &&
            field.select?.id !== "publica",
    );
};
